import Container from "Components/Container/Container";

import projectsData from "constant/project";

import React, { useLayoutEffect, useRef, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import bg from "assests/second-section/line-en.png";
import bg_ar from "assests/second-section/line-ar.png";
import { useTranslation } from "react-i18next";

// import "./style.css";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";
const Projects = ({ data }) => {
  const slideRefs = useRef([]);
  const [maxHeight, setMaxHeight] = useState(0);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { t, i18n } = useTranslation();

  useLayoutEffect(() => {
    // Ensure slideRefs.current is populated
    if (
      slideRefs.current.length === 0 ||
      slideRefs.current.every((ref) => ref === null)
    ) {
      return;
    }

    // Calculate the maximum height after the DOM is fully rendered
    const heights = slideRefs.current.map((slide) => {
      if (slide) {
        return slide.offsetHeight;
      }
      return 0;
    });

    const maxHeight = Math.max(...heights);

    setMaxHeight(maxHeight);
  }, [projectsData]);

  return (
    <section className="py-secondary lg:py-primary bg-gray-200 relative">
      <div className="hidden xl:block absolute left-0 right-0 max-w-[100vw] min-w-[100vw] xl:-top-6 xxl:-top-28">
        <img src={`${i18n.language === "ar" ? bg_ar : bg}`} alt="" />
      </div>
      <Container>
        <div className="flex items-center justify-between">
          <h2 className="text-3xl md:text-4xl lg:text-5xl  titles-font">
            {t("project_home_title")}
          </h2>

          <div className="hidden lg:flex items-center gap-x-1">
            <button
              ref={prevRef}
              className="slider-arrow z-[100] solution-prev-button flex items-center justify-center bg-black text-3xl text-white p-1"
            >
              {i18n.language === "ar" ? <ArrowRight /> : <ArrowLeft />}
            </button>
            <button
              ref={nextRef}
              className="slider-arrow z-[100] solution-next-button flex items-center justify-center bg-black text-3xl text-white p-1"
            >
              {i18n.language === "ar" ? <ArrowLeft /> : <ArrowRight />}
            </button>
          </div>
        </div>
      </Container>

      <div className="mt-14">
        <Swiper
          spaceBetween={6}
          slidesPerView={1.2}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            1200: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
          }}
          modules={[Autoplay, Navigation]}
        >
          {data?.map(({ project_name, image }, index) => (
            <SwiperSlide
              ref={(el) => {
                slideRefs.current[index] = el;
              }}
              style={{
                height: maxHeight ? `${maxHeight}px` : "auto",
              }}
              className="bg-white"
              key={index}
            >
              <div>
                <img className="h-[400px] w-full" src={image} alt="" />
              </div>
              <p className="font-bold uppercase text-black mb-3 text-center mt-2 px-4">
                {project_name}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Projects;
